import React, {createContext, useEffect, useReducer} from 'react'
import MatxLoading from "../../components/MatxLoading";
import SessionOut from "../../views/sessions/SessionOut";
import useError from "../../hooks/useError";

import axios from '../../../axios';

const initialValue = {
    marts: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_DASHBOARD_DATA': {
            return {
                ...state,
                mart_list: action.payload,
            }
        }
        case 'UPDATE_MART': {
            let mart_list = state.mart_list.marts.map(e => {
                return e.id === action.payload.id ? action.payload : e;
            })

            let newMart = {
                marts: mart_list
            }
            return {
                ...state,
                mart_list: newMart,
            }
        }
        case 'ADD_MART': {
            state.mart_list.marts.push(action.payload);
            return {
                ...state,
                mart_list: state.mart_list,
            }
        }
        case 'UNAUTHORIZED': {
            return {
                ...state,
                status: 401,
            }
        }
        default: {
            return state
        }
    }
}

const MartContext = createContext({
    mart_list: initialValue,
    getMarts: () => {},
    addMart: () => {},
    updateMart: () => {},
    uploadImage: () => {},
    getMartById: () => {}
})

export const MartProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)
    const { setError } = useError();

    const getMarts = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/marts/get_marts', options);

            dispatch({
                type: 'LOAD_DASHBOARD_DATA',
                payload: res.data,
            })
        } catch (e) {
            if(e?.response?.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e?.response?.status === 400){
                setError({title: "Error", message: e?.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e?.response?.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            console.error(e)
        }
    }


    const uploadImage = async (data) => {
        try {
            const options = {
                headers : {'Content-Type': 'multipart/form-data'}
            }

            const res = await axios.post('/api/upload_product_image', data, options);

            return res.data;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return null;
        }
    }

    const getMartById = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }
            const res = await axios.get('/api/marts/get_mart/'+id, options);

            return res.data;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return null;
        }
    }

    const addMart = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }
            let res = await axios.post('/api/marts/add_mart', data, options);
            dispatch({
                type: 'ADD_MART',
                payload: res.data
            })
            return res;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return e;
        }
    }

    const updateMart = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            let res = await axios.post('/api/marts/update_mart', data, options);

            dispatch({
                type: 'UPDATE_MART',
                payload: res.data
            })

            return res;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return e;
        }
    }

    useEffect(() => {
        getMarts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    if(state.status === 401){
        return <SessionOut />
    }

    if(state.mart_list === undefined) {
        return <MatxLoading />
    }

    return (
        <MartContext.Provider
            value={{
                mart_list: state.mart_list,
                getMarts,
                addMart,
                updateMart,
                uploadImage,
                getMartById
            }}
        >
            {children}
        </MartContext.Provider>
    )
}

export default MartContext
